/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetTournamentsQueryResponse,
  GetTournaments500,
} from "../types/GetTournaments.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getTournamentsQueryKey = () => [{ url: "/tournaments" }] as const;

export type GetTournamentsQueryKey = ReturnType<typeof getTournamentsQueryKey>;

/**
 * @summary Получение списка всех турниров
 * {@link /tournaments}
 */
export async function getTournaments(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetTournamentsQueryResponse,
    ResponseErrorConfig<GetTournaments500>,
    unknown
  >({ method: "GET", url: `/tournaments`, ...requestConfig });
  return res;
}

export function getTournamentsQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getTournamentsQueryKey();
  return queryOptions<
    ResponseConfig<GetTournamentsQueryResponse>,
    ResponseErrorConfig<GetTournaments500>,
    ResponseConfig<GetTournamentsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getTournaments({ ...config, signal: config.signal ?? signal });
    },
  });
}

/**
 * @summary Получение списка всех турниров
 * {@link /tournaments}
 */
export function useGetTournaments<
  TData = ResponseConfig<GetTournamentsQueryResponse>,
  TQueryData = ResponseConfig<GetTournamentsQueryResponse>,
  TQueryKey extends QueryKey = GetTournamentsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetTournamentsQueryResponse>,
        ResponseErrorConfig<GetTournaments500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey = resolvedOptions?.queryKey ?? getTournamentsQueryKey();

  const query = useQuery(
    {
      ...getTournamentsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetTournaments500>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
